export function treeData (source, id, parentId, children) {
  const cloneData = JSON.parse(JSON.stringify(source))
  return cloneData.filter(father => {
    const branchArr = cloneData.filter(
      child => father[id] === child[parentId]
    )
    // branchArr.length > 0 ? (father[children] = branchArr) : ''
    if (branchArr.length > 0) {
      father[children] = branchArr
    } else {
      father[children] = ''
    }
    return father[parentId] === 0
  })
}

/**
 *基本通用elemnetui的饿的tree
 *
 * @export
 * @param {*} tree
 * @param {*} id
 * @return {*}
 */
export function treeFind (tree, id) {
  var temp = []
  const result = []
  for (let index = 0; index < tree.length; index++) {
    const element = tree[index]
    if (element.powerFather === id) {
      // element
      element.checked = false
      result.push(element)
      temp = treeFind(tree, element.id)
      if (temp.length > 0) {
        element.children = temp
      }
    }
  }
  return result
}
